import { createApp } from 'vue';
import VueClickAway from 'vue3-click-away';
import Leads from './Leads.vue';

export const initLeads = () => {
  if (!document.getElementById('leads-app')) {
    return;
  }

  const app = createApp({
    components: { Leads },
    template: '<Leads/>',
  });

  app.use(VueClickAway);
  app.mount('.lead-manager-new');
};
